<template>
  <div class="login-page">
    <TopHeader from='login'></TopHeader>
    <el-row class="login-content" >
        <!-- <div style="display:flex;justify:space-between;margin:8% 0 0"> -->
          <el-col :xs="0" :sm="12" class="input-login-box over-hidden">
            <div style="width:420px;margin-bottom:24px">
              <img :src="require('$img/left-top-txt.png')" alt="" width="343px" height="72px" style="margin-bottom:24px">
              <img :src="require('$img/left-txt.png')" alt="" width="427px" height="249px">
            </div>
          </el-col>

          <el-col :xs="24" :sm="12" class="input-login-box">
    <!--        默认登录页-->
            <div v-if="defalut" class="content">
              <div style="display: flex;justify-content: space-between;position: relative">
                <span class="login-title">招聘者登录</span>
                <template v-if="employ_product_activity_show > 0">
                  <img :src="require('$img/tcTips.png')" alt="" style="position: absolute;right: 0;bottom: 34px;">
                  <span style="position: absolute;right: 31px;bottom: 44px;z-index:9;color:#F4771D;font-size:12px">限时免费领招聘权益</span>
                </template>
               
                <span style="margin-top: 5px;font-size: 14px;color: #4061F8;cursor: pointer" @click="switchType('register')">没有账号？免费注册 ></span>
              </div>
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="密码登录" name="first">
                  <div class="out-box">
                    <img class="icon" :src="require('$img/tel-icon.png')" alt="">
                    <el-input autofocus v-model="phone" placeholder="手机号" class="input-style" maxlength="11"></el-input>
                  </div>
                  <div class="out-box">
                    <img class="icon" :src="require('$img/password-icon.png')" alt="">
                    <el-input v-model="password" placeholder="密码" show-password class="input-style" maxlength="16" @keyup.enter.native='loginRec'></el-input>
    <!--                <img class="passwordIcon" v-if="!showpassword" :src="require('$img/show-password.png')" alt="" @click="showpassword=true">-->
    <!--                <img class="passwordIcon" v-else :src="require('$img/hide-password.png')" alt="" @click="showpassword=false">-->
                  </div>
                  <el-button type="primary" class="login-btn" @click="loginRec" :loading="btnLoad">登录</el-button>
                  <div style="margin-top: 10px;text-align: right;color:#4061F8;font-size: 12px;cursor: pointer" @click="switchType('forget')">忘记密码</div>
                </el-tab-pane>
                <el-tab-pane label="短信登录" name="second">
                  <div class="out-box">
                    <img class="icon" :src="require('$img/tel-icon.png')" alt="">
                    <el-input autofocus v-model="phone" placeholder="手机号" class="input-style" maxlength="11"></el-input>
                  </div>
                  <div class="out-box">
                    <img class="icon" :src="require('$img/yzm-icon.png')" alt="">
                    <el-input v-model="verification" placeholder="短信验证码" class="input-style" maxlength="6" @keyup.enter.native='loginRec'></el-input>
                    <div class="get-yzm" :class="countdownStatus ? 'hs-style' : ''" @click="getVerNum(1)">
                      {{countdownStatus ? `${overNum}s后重试` : '获取验证码'}}
                    </div>
                  </div>
                  <el-button type="primary" class="login-btn" @click="loginRec" :loading="btnLoad">登录</el-button>
                </el-tab-pane>
              </el-tabs>
            </div>
    <!--        注册页-->
            <div v-if="register" class="content">
              <div style="display: flex;justify-content: space-between">
                <span class="login-title">招聘者注册</span>
                <span style="margin-top: 5px;font-size: 14px;color: #4061F8;cursor: pointer" @click="switchType('default')">已有账号，前往登录 ></span>
              </div>
              <div class="out-box">
                <img class="icon" :src="require('$img/tel-icon.png')" alt="">
                <el-input autofocus v-model="phone" placeholder="手机号" class="input-style" maxlength="11"></el-input>
              </div>
              <div class="out-box">
                <img class="icon" :src="require('$img/yzm-icon.png')" alt="">
                <el-input v-model="verificationRegister" placeholder="短信验证码" class="input-style" maxlength="6" @keyup.enter.native='loginRec'></el-input>
                <div class="get-yzm" :class="countdownStatus ? 'hs-style' : ''" @click="getVerNum(1)">
                  {{countdownStatus ? `${overNum}s后重试` : '获取验证码'}}
                </div>
              </div>
              <div class="out-box">
                <img class="icon" :src="require('$img/password-icon.png')" alt="">
                <el-input v-model="passwordRegister" placeholder="登录密码（6-16位字符）" show-password class="input-style" maxlength="16" @keyup.enter.native='loginRec'></el-input>
    <!--            <img class="passwordIcon" v-if="!showpassword" :src="require('$img/show-password.png')" alt="" @click="showpassword=true">-->
    <!--            <img class="passwordIcon" v-else :src="require('$img/hide-password.png')" alt="" @click="showpassword=false">-->
              </div>
              <!-- <div class="gift">
                <img :src="require('$img/gift.png')" alt="">
                企业审核通过后，可免费领取价值3000元招聘套餐
              </div> -->
              <el-button type="primary" class="login-btn" @click="loginRec" :loading="btnLoad">注册</el-button>
              <div style="margin-top: 12px">注册即代表您已同意<a :href="`${h5Url}/Protocol`" target='_blank'>《地产同行圈用户服务协议》</a></div>
            </div>
    <!--        忘记密码页-->
            <div v-if="forget" class="content">
              <div style="display: flex;justify-content: space-between">
                <span class="login-title">找回密码</span>
              </div>
              <div class="out-box">
                <img class="icon" :src="require('$img/tel-icon.png')" alt="">
                <el-input autofocus v-model="phone" placeholder="手机号" class="input-style" maxlength="11"></el-input>
              </div>
              <div class="out-box">
                <img class="icon" :src="require('$img/yzm-icon.png')" alt="">
                <el-input v-model="verificationForget" placeholder="短信验证码" class="input-style" maxlength="6" @keyup.enter.native='loginRec'></el-input>
                <div class="get-yzm" :class="countdownStatus ? 'hs-style' : ''" @click="getVerNum(1)">
                  {{countdownStatus ? `${overNum}s后重试` : '获取验证码'}}
                </div>
              </div>
              <div class="out-box">
                <img class="icon" :src="require('$img/password-icon.png')" alt="">
                <el-input v-model="passwordForget" placeholder="新登录密码（6-16位字符）" show-password class="input-style" maxlength="16" @keyup.enter.native='loginRec'></el-input>
    <!--            <img class="passwordIcon" v-if="!showpassword" :src="require('$img/show-password.png')" alt="" @click="showpassword=true">-->
    <!--            <img class="passwordIcon" v-else :src="require('$img/hide-password.png')" alt="" @click="showpassword=false">-->
              </div>
              <el-button type="primary" class="login-btn" @click="loginRec" :loading="btnLoad">重置密码</el-button>
              <div style="color: #888D96;font-size: 16px;text-align: center;margin-top: 10px;cursor: pointer" @click="switchType('default')">返回登录</div>
            </div>
          </el-col>
        <!-- </div> -->
      <div class="login-content-bottom">
        — 合作房企 —
        <div>
          <img :src="require('$img/login-bottom.png')" alt="" width="1200px" height="126px">

          <!-- <img :src="require('$img/lingdi.png')" alt="" width="120px" height="32px">
          <img :src="require('$img/rongchuang.png')" alt="" width="120px" height="32px">
          <img :src="require('$img/biguiyuan.png')" alt="" width="120px" height="32px">
          <img :src="require('$img/deshang.png')" alt="" width="120px" height="32px">
          <img :src="require('$img/yuzhou.png')" alt="" width="120px" height="32px">
          <img :src="require('$img/zhenghe.png')" alt="" width="120px" height="32px">
          <img :src="require('$img/yiju.png')" alt="" width="120px" height="32px">
          <img :src="require('$img/jixinxing.png')" alt="" width="120px" height="32px">
          <img :src="require('$img/zhongtie.png')" alt="" width="120px" height="32px">
          <img :src="require('$img/shilianxing.png')" alt="" width="120px" height="32px"> -->
        </div>
      </div>
    </el-row>

    <el-dialog
      :visible.sync="verificationMod"
      width="300px"
      center
      class="modal-cx"
    >
      <div style="margin-bottom: 20px;">获取短信验证码前，请先完成以下验证</div>
      <img class="cap-img" :src="captchaData ? captchaData.src : ''" alt="" @click="getVerNum(0)">

      <el-input v-model="testNumber" maxlength="4" placeholder="请输入验证码"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verificationMod = false">取 消</el-button>
        <el-button type="primary" @click="sendTsNumber">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TopHeader from '$global/TopHeader'
import { createRandomId } from '../../utils/index.js'
import Cookie from 'js-cookie'
import { mapMutations } from 'vuex'

let OverTimeCount = null;

export default {
  data () {
    return {
      h5Url :process.env.VUE_APP_H5_URL,
      phone: '',
      verification: '',
      testNumber: '',
      verificationMod: false,
      captchaData: null,
      randomId: createRandomId(),
      overNum: 0,
      countdownStatus: 0, // 倒计时显示/隐藏
      btnLoad: false,
      activeName: 'first',
      password:'',
      showpassword:false,
      register:false,
      forget:false,
      defalut:true,

      //忘记密码验证码
      verificationForget:'',
      passwordForget:'',
      //注册
      verificationRegister:'',
      passwordRegister:'',
      freeRightNumber: 0,
      employ_product_activity_show:0
    }
  },
  components: {
    TopHeader
  },
  beforeDestroy () {
    OverTimeCount && clearInterval(OverTimeCount)
  },
  created() {
    this.$axios.post('/recruitment/config/startup').then(res => {
        this.employ_product_activity_show = res.data.employ_product_activity_show;
      })
     
  },
  methods: {
    ...mapMutations(['SAVA_USER_INFO']),
    rexTel () {
      let telRex = /^1[3456789]\d{9}$/;
      if (!telRex.test(this.phone)) {
        this.$message('请填写正确的手机号');
        return false
      }
      return true
    },
    switchType(type){
      if(type==='register'){
        this.register=true;
        this.forget=false;
        this.defalut=false;
      }else if(type==='forget'){
        this.forget=true;
        this.register=false;
        this.defalut=false;
      }else if(type==='default'){
        this.defalut=true;
        this.forget=false;
        this.register=false;
      }
      this.password='';
      this.passwordForget='';
      this.passwordRegister='';
      this.verification='';
      this.verificationForget='';
      this.verificationRegister='';
      this.showpassword=false;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 验证码获取展示
    getVerNum (status) {
      if (this.countdownStatus) return false;
      // 判断是否输入手机号
      if (!this.rexTel()) return false;

      // 获取验证图片
      let type=0;
      if(this.register)type=1;
      if(this.defalut)type=2;
      if(this.forget)type=3;
      this.$axios.post('/recruitment/auth/captcha', {
        captcha_token: this.randomId,
        mobile:this.phone,
        type:type
      }).then(res => {
        this.testNumber = '';
        this.captchaData = res.data;
        // 显示
        if (status) {
          this.verificationMod = true
        }
      })
    },
    // 发送验证码
    sendTsNumber () {
      if (this.testNumber.length !== 4) {
        this.$message('请输入验证码');
        return false
      }
      let type=0;
      if(this.register)type=1;
      if(this.defalut)type=2;
      if(this.forget)type=3;
      this.$axios.post('/recruitment/auth/sendCode', {
        mobile: this.phone,
        captcha: this.testNumber,
        captcha_token: this.randomId,
        type:type
      }).then(() => {
        this.verificationMod = false;
        this.$success('验证码已发送');
        this.countdownSet()
      })
    },
    // 倒计时
    countdownSet () {
      let over = 120;
      let self = this;
      this.countdownStatus = 1;
      self.overNum = over;
      OverTimeCount = setInterval(() => {
        over--;
        self.overNum = over;
        if (over === 0) {
          clearInterval(OverTimeCount);
          self.countdownStatus = 0
        }
      }, 1000)
    },
    // 登录
    loginRec () {
      if (!this.rexTel()) return false;
      if(this.defalut){
        if(this.activeName==='first'){
          //密码登录
          if(this.password.length<6){
            this.$message('请填写正确的密码（6~16位）');
            return false
          }
          this.btnLoad = true;

          let data = {
            mobile: this.phone,
            password: this.password
          };
          // eslint-disable-next-line no-unreachable
          if (this.$route.query && this.$route.query.u) {
            data.invite_user_id = this.$route.query.u
          }
          this.$axios.post('/recruitment/auth/loginpwd', data).then(res => {
            Cookie.set('pc_token', res.data.pc_token, {expires: 7});
            this.SAVA_USER_INFO(res.data);
            this.$router.push('/')
          }).finally(() => {
            this.btnLoad = false
          })
        }else{
          //验证码登录
          if (!this.verification) {
            this.$message('请填写短信验证码');
            return false
          }
          if (this.verification.length !== 6) {
            this.$message('请填写正确的短信验证码');
            return false
          }
          this.btnLoad = true;

          let data = {
            mobile: this.phone,
            code: this.verification
          };

          // eslint-disable-next-line no-unreachable
          if (this.$route.query && this.$route.query.u) {
            data.invite_user_id = this.$route.query.u
          }

          this.$axios.post('/recruitment/auth/logincaptcha', data).then(res => {
            Cookie.set('pc_token', res.data.pc_token, {expires: 7});
            this.SAVA_USER_INFO(res.data);
            this.$router.push('/')
          }).finally(() => {
            this.btnLoad = false
          })
        }
      }
      if(this.forget){
        //忘记密码
        if (!this.verificationForget) {
          this.$message('请填写短信验证码');
          return false
        }
        if (this.verificationForget.length !== 6) {
          this.$message('请填写正确的短信验证码');
          return false
        }
        if(this.passwordForget.length<6){
          this.$message('请填写正确的新登录密码（6~16位）');
          return false
        }
        this.btnLoad = true;

        let data = {
          mobile: this.phone,
          code: this.verificationForget,
          password:this.passwordForget
        };

        // eslint-disable-next-line no-unreachable
        if (this.$route.query && this.$route.query.u) {
          data.invite_user_id = this.$route.query.u
        }

        this.$axios.post('/recruitment/auth/resetpwd', data).then(res => {
          console.log(res);
          this.$message({
            message: '重置密码成功，请重新登录',
            type: 'success'
          });
          setTimeout(()=>{
            this.forget=false;
            this.defalut=true;
            this.password='';
            this.passwordForget='';
            this.verificationRegister='';
            this.passwordRegister='';
            this.showpassword=false;
          },1000)
        }).finally(() => {
          this.btnLoad = false
        })
      }
      if(this.register){
        //忘记密码
        if (!this.verificationRegister) {
          this.$message('请填写短信验证码');
          return false
        }
        if (this.verificationRegister.length !== 6) {
          this.$message('请填写正确的短信验证码');
          return false
        }
        if(this.passwordRegister.length<6){
          this.$message('请填写正确的密码（6~16位）');
          return false
        }
        this.btnLoad = true;

        let data = {
          mobile: this.phone,
          code: this.verificationRegister,
          password:this.passwordRegister
        };

        // eslint-disable-next-line no-unreachable
        if (this.$route.query && this.$route.query.u) {
          data.invite_user_id = this.$route.query.u
        }

        this.$axios.post('/recruitment/auth/register', data).then(res => {
          this.$message({
            message: '注册成功，正在跳转',
            type: 'success'
          });
          setTimeout(()=>{
            Cookie.set('pc_token', res.data.pc_token, {expires: 7});
            this.SAVA_USER_INFO(res.data);
            this.$router.push('/')
          },1000)
        }).finally(() => {
          this.btnLoad = false
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '$styles/global.scss';

.login-page{
  width: 100%;
  height: 100%;
  color: $main-color;

  .cap-img{
    width: 50%;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .bottom-ts{
    font-size: 12px;
    width: 100%;
    margin-top: 13px;
    text-align: center;
    color: $last-color;
  }

  .login-content{
    height: calc(100% - 58px);
    background: url('../../assets/img/login-bg.png') no-repeat;
    background-size: cover;
    width: 100%;
    padding-top: 8%;
    overflow: auto;
    min-height: 746px;
    .input-login-box{
      // padding-left:15%
      @include flex-box();
    }

    .over-hidden{
      overflow: hidden;

    }

    .content{
      width:400px;
      padding: 40px 40px 30px;
      box-sizing: border-box;
      background-color: #FFF;
      border-radius: 10px;
      .el-tabs__active-bar{
        margin-left: 13px;
        width: 28px !important;
        height: 4px;
        border-radius: 3px;
      }
      .el-tabs__nav-wrap::after{
        background-color:initial;
      }
      .login-title{
        font-size: 20px;
        margin-bottom: 15px;
        font-weight: bold;
      }

      .out-box{
        position: relative;

        .icon{
          width: 28px;
          height: 28px;
          position: absolute;
          top: 7px;
          left: 7px;
          z-index: 5;
        }

        .get-yzm{
          color: $guide-color;
          font-size: 16px;
          position: absolute;
          top: 10px;
          right: 20px;
          z-index: 5;
          cursor: pointer;
        }
        .passwordIcon{
          font-size: 16px;
          position: absolute;
          top: 9px;
          right: 7px;
          z-index: 5;
          cursor: pointer;
        }
      }
      .gift{
        display: flex;
        color: #F4771D;
        font-size: 12px;
        margin-bottom:4px
      }
      .input-style{
        margin-bottom: 20px;

        input{
          height: 42px;
          width: 100%;
          box-sizing: border-box;
          padding-left: 40px;
          font-size: 16px;
        }
        input:focus{
          border-radius: 4px!important;
        }
        input::-webkit-input-placeholder{
          font-size: 16px;
        }
      }
    }

    .yzm-style{
      color: $guide-color;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }

    .hs-style{
      color: $second-color;
    }

    .login-btn{
      width: 100%;
      height: 50px;

      span{
        // letter-spacing: 16px;
        margin: 0 10px;
      }

    }
    .login-content-bottom{
      width:100%;
      color:#fff;
      font-size:16px;
      text-align:center;
      left: 0;
      bottom: 20px;
      position: absolute;
      &>div{
        display:flex;
        flex-wrap: wrap;
        align-content: center;
        max-width: 1200px;
        margin: auto;
        img{
          margin:20px 20px 0 20px;
        }
      }
    }
  }
  .is-active{
    color: #3C4554 !important;
    font-size: 16px !important;
    font-weight: bold !important;    
  }
  .el-tabs__item{
    color: #888D96;
    font-size: 12px;
  }
  .el-tabs__header{
    margin-bottom: 20px;
  }
}
</style>
